import { Box, Container, Flex } from '@chakra-ui/react'
import { useEffect, useMemo } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { useAxiosInterceptors } from '../hooks/useAxiosInterceptors'
import { useI18nRoute } from '../hooks/useI18nRoute'
import { useLogin } from '../hooks/useLogin'
import useScrollToTop from '../hooks/useScrollTop'
import { SteamImageProvider } from '../provider/SteamImageProvider'
import Header from '../components/Header'
import Footer from '../components/Footer'
import GemBg from '../assets/GemBg.png'
import topbg from '../assets/openboxbg.webp'
import useInitUser from '../hooks/useInitUser'
import { useTrackLocation } from '../hooks/useTrackLocation'
import TopDrops from '../components/TopDrops'

import '../components/Icons/index'
import useGemBalance from '../hooks/useGemBalance'
import useGemSkinsValue from '../hooks/useGemSkinsValue'
import RushSkinsModal from '../components/RushSkinsModal'

const RouteGuard = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const { lang } = useParams()

  // useEffect(() => {
  //   const pathname = location.pathname
  //   const pathWithoutLang = pathname.replace(`/${lang}`, '')

  //   // Check if current path is allowed
  //   const isAllowed = pathWithoutLang.startsWith('/')

  //   if (!isAllowed) {
  //     navigate(`/${lang}`, { replace: true })
  //   }
  // }, [location.pathname, navigate, lang])

  return <>{children}</>
}

const AppContent = () => {
  useLogin()
  useScrollToTop()
  useI18nRoute()
  useGemBalance()
  useGemSkinsValue()
  useInitUser()
  useTrackLocation()
  // useBulletBalance()
  // useUserSkinsTotalValue()
  // useUserFreeCaseAmount()
  const pathname = useLocation()
  const isDetail = pathname.pathname.includes('detail')

  const backGroundImage = useMemo(() => {
    if (isDetail) return topbg
    return GemBg
  }, [isDetail])

  return (
    <RouteGuard>
      <SteamImageProvider>
        <Box
          position="absolute"
          top={0}
          left={0}
          w="100%"
          h="100%"
          zIndex={-1}
          backgroundImage={backGroundImage}
          backgroundSize={'100vw auto'}
          backgroundRepeat={'no-repeat'}
          backgroundPosition={'top center'}
        />

        <Container maxW={'1800px'} px="0px">
          <Header />
          <TopDrops />
          <Flex minH="100vh" flexDir={'column'} position="relative">
            <Box flex={1}>
              <Outlet />
            </Box>
          </Flex>
          <Footer />
        </Container>
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          style={{
            fontSize: '14px',
          }}
        />
        <RushSkinsModal />
      </SteamImageProvider>
    </RouteGuard>
  )
}

const Root = () => {
  const isInterceptorsReady = useAxiosInterceptors()
  if (!isInterceptorsReady) {
    return null // 或者返回一个加载指示器
  }

  return <AppContent />
}

export default Root
